<template>
  <!-- 财务-首页 -->
  <div>
    <div>
      <!-- <a-row type="flex" justify="space-between" :gutter="16" style="margin-bottom: 14px;">
        <a-col :span="24">
          <personalOutlaysVue style="height: 200px;" />
        </a-col>
      </a-row>-->
      <a-row type="flex" justify="space-between" :gutter="16">
        <a-col :span="12">
          <briefingBoardVue style="height: 450px;" />
        </a-col>
        <a-col :span="6">
          <paymentPlanChartVue style="height: 450px;" />
        </a-col>
        <a-col :span="6">
          <internalAnnouncementVue @noticeTitled="noticeTitled" style="height: 450px;" />
        </a-col>
      </a-row>
      <a-row
        type="flex"
        justify="space-between"
        :gutter="16"
        style="margin-top:10px;margin-bottom: 20px;"
      >
        <a-col :span="8">
          <approveVue
            @documentsJumped="documentsJumped"
            @titleClick="titleClick"
            @approvaled="approvaled"
            ref="approveVue"
            style="height: 692px;"
          />
        </a-col>
        <a-col :span="16">
          <a-row>
            <invoiceListVue
              @invoiceListChange="invoiceListChange"
              ref="invoiceListVue"
              style="height: 340px;background-color:#fff;"
            />
          </a-row>
          <a-row style="margin:10px 0;height: 340px;background-color:#fff;border-radius:10px;">
            <expenseReimInfoVue />
          </a-row>
        </a-col>
      </a-row>
      <!-- <a-row type="flex" justify="space-between" :gutter="16" style="margin: 10px 0;">
      </a-row>-->
    </div>
    <public-drawer
      ref="publicDrawerRef"
      :title="publicDrawer.title"
      :dialog-visible="publicDrawer.visible"
      :component-name="publicDrawer.comName"
      @projectChanges="publicDialogSucc"
      @close="handleClose"
    />
    <audit
      ref="auditRef"
      :dialog-visible="auditVisible"
      @projectChanges="projectChanges"
      @success="auditSucc"
      @close="auditClose"
    />
    <add-edit
      ref="addEditRef"
      :title="addTitle"
      :dialog-visible="addVisible"
      @success="addSuccess"
      @close="addClose"
    />
    <click-view ref="clickViewRef" :dialog-visible="clickViewVisible" @close="clickViewClose" />
  </div>
</template>

<script>
// 模块引入
import approveVue from '@/components/homeComponents/approve.vue' // 审批
import briefingBoardVue from '@/components/homeComponents/briefingBoard.vue' // 简报看板
import personalOutlaysVue from '@/components/homeComponents/personalOutlays.vue' // 个人财年支出
import paymentPlanChartVue from '@/components/homeComponents/paymentPlanChart.vue' // 付款计划统计
import expenseReimInfoVue from '@/components/homeComponents/expenseReimInfo.vue' // 待支取费用报销
import invoiceListVue from '@/components/homeComponents/invoiceList.vue' // 回款未开票列表
import internalAnnouncementVue from '@/components/homeComponents/internalAnnouncement.vue' // 内部公告
import publicDrawer from '../../components/drawer/copyDrawer.vue'
import audit from '../approvalManage/approvalData/audit.vue'
import addEdit from '../financialManage/billingRecords/addEdit.vue'
import clickView from '@/components/view/clickView.vue'

export default {
  name: 'AdminHome',
  components: {
    approveVue,
    briefingBoardVue,
    expenseReimInfoVue,
    personalOutlaysVue,
    internalAnnouncementVue,
    invoiceListVue,
    paymentPlanChartVue,
    publicDrawer,
    audit,
    addEdit,
    clickView
  },
  data () {
    return {
      auditVisible: false,
      userId: '',
      addTitle: '',
      clickViewVisible: false,
      addVisible: false,
      publicDrawer: {
        title: '',
        visible: false,
        comName: ''
      }
    }
  },
  beforeMount () {
    this.userId = this.$store.state.account.user.userId
  },
  methods: {
    noticeTitled (item) {
      this.publicDrawer.title = this.$tree([], 'system/notice/index')
      this.publicDrawer.visible = true
      this.publicDrawer.comName = 'system/notice/noticeDraw.vue'
      this.$nextTick(() => {
        this.$refs.publicDrawerRef.setForm(item)
      })
    },
    publicDialogSucc (value, name) {
      this.openView(value, name)
      // this.publicDrawer.visible = false
    },
    handleClose () {
      this.publicDrawer.visible = false
    },
    auditSucc () {
      this.auditVisible = false
      this.$refs.approveVue.approvalFrtch({ status: 4, userId: this.userId })
    },
    auditClose () {
      this.auditVisible = false
    },
    approvaled (value) {
      this.auditVisible = true
      this.$nextTick(() => {
        this.$refs.auditRef.setId(value)
      })
    },
    // 点击详情
    documentsJumped (item) {
      this.documentsJump(item.rowVal, item.num)
    },
    invoiceListChange (item) {
      this.addTitle = '[新建]-开票记录'
      this.addVisible = true
      this.$refs.addEditRef.setForm(item, 1)
    },
    addSuccess () {
      this.addVisible = false
      this.$refs.invoiceListVue.initData()
    },
    addClose () {
      this.addVisible = false
      this.$refs.invoiceListVue.initData()
    },
    clickViewClose () {
      this.clickViewVisible = false
    },
    projectChanges (value, name) {
      // this.publicDia.visible = false
      if (name === 'project') {
        console.log('value.projectId =>', value.projectId)
        this.$get('/project/list', { id: value.projectId }).then(res => {
          // this.projectInfo = res.data.data.rows[0]
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.openView(res.data.data.rows[0], 'project')
          } else {
            this.$message.warning('未查询到该数据，可能已删除或者没有操作权限，请检查！', 5)
          }
        })
      }
      if (name === 'customerName') this.openView(value, name)
      if (name === 'purchaseName') this.openView(value, name)
      if (name === 'contractName') this.openView(value, name)
      if (name === 'salesOpportunities') this.openView(value, name)
    },
    openView (rowVal, name) {
      this.clickViewVisible = true
      if (name === 'purchaseName') {
        if (rowVal.purchaseId) this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.purchaseId)
        else this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.id)
      } else if (name === 'customerName') {
        this.$refs.clickViewRef.openView('customer', rowVal, rowVal.customerId)
      } else if (name === 'project') {
        this.$refs.clickViewRef.openView('project', rowVal, rowVal.projectId)
      } else if (name === 'contractName') {
        this.$refs.clickViewRef.openView('contract', rowVal, rowVal.id)
      } else if (name === 'salesOpportunities') {
        this.$refs.clickViewRef.openView('salesOpportunities', rowVal, rowVal.opportunityId)
      }
    },
    titleClick (record, num) {
      if (record.copyType === 58) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'financialManage/expenseReim/index')
          // this.publicDrawer.visible = true
          this.publicDrawer.comName = 'financialManage/expenseReim/show.vue'
          this.$get('/reimbursement/getById', { id: record.recordId }).then(res => {
            if (res.data.data) {
              // this.publicDrawer.title = '费用报销'
              this.publicDrawer.visible = true
              // this.publicDrawer.comName = 'financialManage/expenseReim/show.vue'
              this.$refs.publicDrawerRef.setForm(res.data.data)
            } else {
              this.$message.warning('暂无详情!')
            }
          })
          // this.$nextTick(() => {
          //   this.$refs.publicDrawerRef.setForm(record.reimbursement)
          // })
        } else {
          this.openView(record, 'customerName')
        }
      } else if (record.copyType === 15) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'salesOpportunities/todoTask/index')
          this.publicDrawer.comName = 'salesOpportunities/todoTask/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.saleTask)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 16) {
        if (num === 1) {
          this.openView(record.saleOpportunity, 'salesOpportunities')
        } else {
          this.openView(record, 'customerName')
        }
      } else if (record.copyType === 17) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'contractManage/contractManagement/index')
          this.publicDrawer.comName = 'contractManage/contractManagement/details.vue'
          this.publicDrawer.visible = true
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.supplement)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === -13) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'contractManage/paymentPlan/index')
          this.publicDrawer.comName = 'contractManage/paymentPlan/show.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.payBack)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 14) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'inventory/returnWarehouse/index')
          this.publicDrawer.comName = 'inventory/returnWarehouse/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.stockToBack)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 13) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'contractManage/paymentRecord/index')
          this.publicDrawer.comName = 'contractManage/paymentRecord/show.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.payBack)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === -36) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'purchase/paymentSchedule/index')
          this.publicDrawer.comName = 'purchase/paymentSchedule/paymentInfor.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.payPlan)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 36) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'purchase/paymentRecords/index')
          this.publicDrawer.comName = 'purchase/paymentRecords/recordInform.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.payPlan)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 57) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = '预支预付'
          this.publicDrawer.comName = 'financialManage/advance/show.vue'
          this.$get('/prePayment/getById', { id: record.prePayment.id }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
          // this.$nextTick(() => {
          //   this.$refs.publicDrawerRef.setForm(record.prePayment)
          // })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 21) {
        if (num === 1) this.openView(record.purchase, 'purchaseName')
        else this.openView(record, 'customerName')
      } else if (record.copyType === 39) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'purchase/purchaseRequest/index')
          this.publicDrawer.comName = 'purchase/purchaseRequest/show.vue'
          this.publicDrawer.visible = true
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.purchaseRequisition)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 8) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'financialManage/ticketReceiptRecord/index')
          this.publicDrawer.comName = 'financialManage/ticketReceiptRecord/viewCollection.vue'
          this.publicDrawer.visible = true
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.invoice)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 27) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'financialManage/billingRecords/index')
          this.publicDrawer.comName = 'financialManage/billingRecords/viewBill.vue'
          this.publicDrawer.visible = true
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.invoice)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 11) {
        console.log('record.contract =>', record.contract)
        if (num === 1) this.openView(record.contract, 'contractName')
        else this.openView(record, 'customerName')
      } else if (record.copyType === 47) {
        if (num === 1) this.openView(record.project, 'project')
        else this.openView(record, 'customerName')
      } else if (record.copyType === 999) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'financialManage/largeAmountApplication/index')
          this.publicDrawer.comName = 'financialManage/largeAmountApplication/show.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.bigAmountApplicationVo)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 888) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'projectManage/laborAndMaterial/index')
          this.publicDrawer.comName = 'projectManage/laborAndMaterial/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.projectReporting)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 777) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'projectManage/projectProposals/index')
          this.publicDrawer.comName = 'projectManage/projectProposals/detail.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.projectApproval)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 666) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'offices/courtesyApplication/index')
          this.publicDrawer.comName = 'offices/courtesyApplication/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.festivalGiftVo)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 333) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'offices/travelRecords/index')
          this.publicDrawer.comName = 'offices/travelRecords/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.outWork)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 555) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'offices/overtimeRecords/index')
          this.publicDrawer.comName = 'offices/overtimeRecords/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.workOvertime)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 12) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'inventory/takeItBack/index')
          this.publicDrawer.comName = 'inventory/takeItBack/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.stockReceiveVo)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 48) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'manpower/recruitmentDemand/index')
          this.publicDrawer.comName = 'manpower/recruitmentDemand/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.recruitment)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 49) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'contractManage/earnestMoney/index')
          this.publicDrawer.comName = 'contractManage/earnestMoney/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.performanceBond)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 50) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'offices/vehicleDepartureRecord/index')
          this.publicDrawer.comName = 'offices/vehicleDepartureRecord/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.vehicleDepartureRecord)
          })
        } else this.openView(record, 'customerName')
      } else if (record.copyType === 51) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'offices/returnCarRecord/index')
          this.publicDrawer.comName = 'offices/returnCarRecord/details.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(record.vehicleDepartureRecord)
          })
        } else this.openView(record, 'customerName')
      }
      this.$refs.publicDrawerRef.isButtonShowFun(1)
    },
    documentsJump (rowVal, num) {
      if (rowVal.checkType === 0) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'financialManage/expenseReim/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'financialManage/expenseReim/show.vue'
          this.$get('/reimbursement/getById', { id: rowVal.recordId }).then(res => {
            this.$refs.publicDrawerRef.setForm(res.data.data)
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 1) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'purchase/purchaseNote/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'purchase/purchaseNote/viewDrawer.vue'
          this.$nextTick(() => {
            this.$refs.publicDrawerRef.setForm(rowVal.recordId)
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 2) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = '预支预付'
          this.publicDrawer.comName = 'financialManage/advance/show.vue'
          this.$get('/prePayment/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 3 || rowVal.checkType === 4) {
        if (num === 1) {
          if (rowVal.isBack === 0) {
            this.publicDrawer.visible = true
            this.publicDrawer.title = this.$tree([], 'contractManage/paymentRecord/index')
            this.publicDrawer.comName = 'contractManage/paymentRecord/show.vue'
            this.$get('/payBack/getById', { backType: 1, id: rowVal.recordId }).then(res => {
              if (res.data.status === 1) {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              }
            })
          } else if (rowVal.isBack === 1) {
            this.publicDrawer.visible = true
            this.publicDrawer.title = this.$tree([], 'purchase/paymentSchedule/index')
            this.publicDrawer.comName = 'purchase/paymentSchedule/paymentInfor.vue'
            this.$get('/payPlan/getById', { payType: 0, id: rowVal.recordId }).then(res => {
              if (res.data.status === 1) {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              }
            })
          }
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 5) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'offices/travelRecords/index')
          this.publicDrawer.comName = 'offices/travelRecords/details.vue'
          this.$get('outwork/byId', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 6) {
        if (num === 1) {
          this.publicDrawer.visible = true
          this.publicDrawer.title = this.$tree([], 'offices/overtimeRecords/index')
          this.publicDrawer.comName = 'offices/overtimeRecords/details.vue'
          this.$get('outwork/byId', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 7) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'financialManage/largeAmountApplication/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'financialManage/largeAmountApplication/show.vue'
          this.$get('bigAmount/byId', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 8) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'projectManage/projectProposals/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'projectManage/projectProposals/detail.vue'
          this.$get('projectApproval/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 9) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'offices/courtesyApplication/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'offices/courtesyApplication/details.vue'
          this.$get('/festivalGift/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 10) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'inventory/takeItBack/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'inventory/takeItBack/details.vue'
          this.$get('/stockReceive/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 12) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'manpower/recruitmentDemand/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'manpower/recruitmentDemand/details.vue'
          this.$get('/recruitment/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 13) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'contractManage/earnestMoney/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'contractManage/earnestMoney/details.vue'
          this.$get('/performance/getById', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 14) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'offices/vehicleDepartureRecord/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'offices/vehicleDepartureRecord/details.vue'
          this.$get('/outCar/byId', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      } else if (rowVal.checkType === 15) {
        if (num === 1) {
          this.publicDrawer.title = this.$tree([], 'offices/returnCarRecord/index')
          this.publicDrawer.visible = true
          this.publicDrawer.comName = 'offices/returnCarRecord/details.vue'
          this.$get('/returnCar/byId', { id: rowVal.recordId }).then(res => {
            if (res.data.status === 1) {
              this.$nextTick(() => {
                this.$refs.publicDrawerRef.setForm(res.data.data)
              })
            }
          })
        } else this.openView(rowVal, 'customerName')
      }
      this.$refs.publicDrawerRef.isButtonShowFun(1)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/roleHome/financeHome.vue